import { render } from "./PortalActiveSwitch.vue?vue&type=template&id=9ac32f16&scoped=true"
import script from "./PortalActiveSwitch.vue?vue&type=script&lang=js"
export * from "./PortalActiveSwitch.vue?vue&type=script&lang=js"

import "./PortalActiveSwitch.vue?vue&type=style&index=0&id=9ac32f16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ac32f16"]])

export default __exports__